import { beMessApiGetAllMessages } from 'Api/BeMessApi'
import { beStatApiExportEmailMessageList } from 'Api/BeStatApi'
import {
  STORE_KEY_ID_LIST,
  STORE_KEY_LIST,
  SERVICE_TYPE_SMTPPLUS,
  SERVICE_TYPE_FASTEMAIL,
  MESSAGE_TYPE_GENERIC,
  MESSAGE_TYPE_WELCOME,
  MESSAGE_TYPE_CONFIRMATION
} from 'Constants'
import { storeGet } from 'Helpers/localStorage'
import { isUnsignedInteger } from 'Helpers/validators'
import { handleFrom, handleTo } from 'Helpers/dates'
import { beAccountDeliverabilityApiGetDeliverabilityIndex } from 'Api/beAccountDeliverabilityApi'
import { ID_LIST_STORE_KEY } from 'Constants/index'

export async function getDeliverabilityIndex() {
  const list = storeGet(ID_LIST_STORE_KEY)

  const result = await beAccountDeliverabilityApiGetDeliverabilityIndex({
    list
  })

  if (!result.AlertsData) {
    result.AlertsData = {}
  }

  const { CampaignNumber, ScoreData } = result
  const ret =
    CampaignNumber > 0 && ScoreData
      ? result
      : { ...result, ScoreData: { ...ScoreData, Score: -1 } }

  return ret
}

export const fetchMessages = params => {
  const idList = parseInt(storeGet(STORE_KEY_ID_LIST))

  let conditions = getSMTPPlusServiceTypeConditions()

  if (!params) {
    return beMessApiGetAllMessages(idList, conditions.join(' && '), '', 1, 10)
  }

  const {
    searchText,
    filterByField,
    filterByFieldFrom,
    filterByFieldTo,
    orderBy,
    orderDesc,
    pageNumber,
    pageSize
  } = params

  conditions = conditions.concat([
    ...(searchText ? makeConditionSearchText(searchText) : []),
    ...makeConditionFilterFrom(filterByField, filterByFieldFrom),
    ...makeConditionFilterTo(filterByField, filterByFieldTo)
  ])

  return beMessApiGetAllMessages(
    idList,
    conditions.join(' && '),
    orderBy ? `${orderBy} ${orderDesc ? 'DESC' : 'ASC'}` : undefined,
    pageNumber,
    pageSize
  ).then(result => {
    if (!result.Items.length && result.TotalItems && result.PageNumber > 1) {
      const newPageNumber = Math.ceil(result.TotalItems / pageSize)

      return beMessApiGetAllMessages(
        idList,
        conditions.join(' && '),
        orderBy ? `${orderBy} ${orderDesc ? 'DESC' : 'ASC'}` : undefined,
        newPageNumber,
        pageSize
      )
    } else {
      return result
    }
  })
}

export const exportSMTPPlusMessages = (searchForm, exportType) => {
  const idList = parseInt(storeGet(STORE_KEY_ID_LIST))
  const tz = storeGet(STORE_KEY_LIST).TimeZoneCode
  const exportParams = {
    IdList: idList,
    SearchText: searchForm.searchText,
    SearchInBody: false,
    DateFrom: searchForm.filterByFieldFrom
      ? handleFrom(searchForm.filterByFieldFrom, tz)
      : undefined,
    DateTo: searchForm.filterByFieldTo
      ? handleTo(searchForm.filterByFieldTo, tz)
      : undefined,
    MessageType: [
      MESSAGE_TYPE_GENERIC,
      MESSAGE_TYPE_WELCOME,
      MESSAGE_TYPE_CONFIRMATION
    ],
    ServiceType: [SERVICE_TYPE_SMTPPLUS, SERVICE_TYPE_FASTEMAIL],
    //  Archived: ,
    //  Published: ,
    OrderBy: `${searchForm.orderBy} ${searchForm.orderDesc ? 'DESC' : 'ASC'}`,
    ExportType: exportType
  }

  return beStatApiExportEmailMessageList(1, 0, exportParams)
}

function makeConditionSearchText(searchText) {
  const trimmedSearchText = searchText
    .trim()
    .replace(/\\/g, '\\\\')
    .replace(/'/g, "\\'")
  return isUnsignedInteger(trimmedSearchText)
    ? [
        `(Id == ${trimmedSearchText} || (Note.Contains('${trimmedSearchText}') || Subject.Contains('${trimmedSearchText}')))`
      ]
    : [
        `((Note.Contains('${trimmedSearchText}') || Subject.Contains('${trimmedSearchText}')))`
      ]
}

function getSMTPPlusServiceTypeConditions() {
  return [
    `((ServiceType == ${SERVICE_TYPE_SMTPPLUS}) || (ServiceType == ${SERVICE_TYPE_FASTEMAIL}))`
  ]
}

function makeConditionFilterFrom(fieldName, date) {
  const tz = storeGet(STORE_KEY_LIST).TimeZoneCode
  const strDate = handleFrom(date, tz)
  return strDate ? [`( ${fieldName} >= #${strDate}#)`] : []
}

function makeConditionFilterTo(fieldName, date) {
  const tz = storeGet(STORE_KEY_LIST).TimeZoneCode
  const strDate = handleTo(date, tz)
  return strDate ? [`( ${fieldName} <= #${strDate}#)`] : []
}
